import {
	getUserInfo,
	getCurrTime,
	getAddressList,
	getTicket,
	getCouponList,
	getActSection,
	glogin,
	getTop100Left,
	getOpenid,
	getOrderList
} from '../api/getData'
import {
	GET_USERINFO,
	ACT_PROGRESS,
	SAVE_ADDRESS,
	GET_TICKET,
	GET_VOUCHER,
	GET_PRODUCT,
	RECORD_USERINFO,
	GET_GOSTYLE,
	GET_BGIMAGE,
	GET_GIFT,
	GET_ORDERLIST
} from './mutation-types.js'
import {
ACT_P_ORDER,
ACT_ORDER,
ACT_GO,
ACT_E_GO
} from '../constant/act_stat'
import { giftQuantity } from '../constant/products';

export default {
	async getTicket({
		commit,
		state
	}) {
		let res = await getTicket();	
		console.log("getTicket res:",res)		
		let ticket = res
		console.log("getTicket ticket:",ticket)
		commit(GET_TICKET, ticket)
	},
	async getDeviceInfo({
		commit,
		state
	}) {
		let res = await getDeviceInfo();	
		console.log("getDeviceInfo res:",res)		
		let device_info = res
		console.log("getDeviceInfo device_info:",device_info)
		commit(GET_DEVICEINFO, device_info)
	},	
	async requestLogin({
		commit,
		state
	}) {
		let res = await glogin();	
		console.log("requestLogin res:",res)		
		let ticket = res.ticket
		console.log("requestLogin ticket:",ticket)
		commit(GET_TICKET, ticket)
		let userInfo = {
			'uuid': res.uuid,
			'nickname': res.nickname,
			'avatar': res.avatar,
			'ticket': res.ticket,
			'vip_id': res.vipLevel,
		}
		
		commit(RECORD_USERINFO, userInfo)
	},
	async getUserInfo({
		dispatch,
		commit,
		state
	}) {
		console.log("getUserInfo等待getTicket")
		await dispatch('getTicket')
		console.log("getUserInfo getTicket完成")
		let ticket = state.ticket
		console.log("getUserInfo ticket",ticket)
		if(!ticket)
			return;
		let res = await getUserInfo(ticket);	
		if(!res||res.err!=0||!res.data)	
		{
			console.log(res.msg)
			return;
		}
		let userInfo = {
			'uuid': res.data.uuid,
			'nickname': res.data.nickname,
			'avatar': res.data.avatar,
			'ticket': res.data.ticket,
			'vip_id': res.data.vip_id,
		}
		console.log("getUserInfo",userInfo)
		commit(RECORD_USERINFO, userInfo)
	},
	async getActInfo({
		commit,
		state
	}) {
		let res = await getActSection();
		let status = null
		if(state.urlParams.test_m){
			
			status = state.urlParams.test_m
		}
		else{
			if(res)
				status = String(res.data)
		}
		switch(status){
			case "0":status = ACT_P_ORDER;break;
			case "1":status = ACT_ORDER;break;
			// case "2":status = ACT_E_ORDER;break;
			// case "3":status = ACT_P_GO;break;
			case "2":status = ACT_GO;break;
			case "3":status = ACT_E_GO;break;
		}
		// console.log("活动阶段固定（测试），上线请删除")
		// status = ACT_GO//活动阶段固定（测试），上线请删除
		let actInfo = {
			'progress':status
		}
		console.log("getActInfo",actInfo)
		commit(ACT_PROGRESS, actInfo)
		commit(GET_PRODUCT)
		commit(GET_BGIMAGE, actInfo)		
	},
	async getVoucher({
		dispatch,
		commit,
		state
	}) {
		
		console.log("getVoucher等待getActInfo")
		await dispatch('getActInfo')
		console.log("getVoucher getActInfo完成")
		if(!state.product)
			return
		let productId = state.product.id
		console.log("getVoucher productId",productId)

		console.log("getVoucher等待getUserInfo")
		await dispatch('getUserInfo')
		console.log("getVoucher getUserInfo完成")
		let ticket = state.ticket
		let islogin = state.islogin
		console.log("getVoucher ticket",ticket)
		console.log("getVoucher islogin",islogin)		
		if(!islogin)
			return
		let res = await getCouponList(ticket,productId);
		let item = {}
		if(res.err==0){
			if(res.data.length>0){
				let element = res.data[0]
				item.id= element.id
				item.name = item.id
				item.title = element.des
				item.amount = element.amount
				item.checked = true		
			}
		}
		console.log("getVoucher item",item)
		commit(GET_VOUCHER, item)
		commit(GET_GOSTYLE, item)
	},
	async getGift({
		dispatch,
		commit,
		state
	}) {
		
		console.log("getGift等待getActInfo")
		await dispatch('getActInfo')
		console.log("getGift getActInfo完成")
		console.log("getGift getActInfo progress",state.actInfo)
		if(state.actInfo.progress!=ACT_GO)
			return		
		let res = await getTop100Left();		
		console.log("getGift res",res)
		commit(GET_GIFT, res)
	},
	async getOpenId({
		dispatch,
		commit,
		state
	}) {		
		if(!state.urlParams||!state.urlParams.code)
			return		
		const code = state.urlParams.code;
		let res = await getOpenid(code);		
		console.log("getGift res",res)
		commit(GET_OPENID, res)
	},
	async getOrderList({
		dispatch,
		commit,
		state
	}) {		
		console.log("getOrderList 等待getTicket")
		await dispatch('getTicket')
		console.log("getOrderList getTicket完成")
		let ticket = state.ticket
		console.log("getOrderList ticket",ticket)
		if(!ticket)
			return;
		let res = await getOrderList(ticket);		
		console.log("getOrderList res",res)
		commit(GET_ORDERLIST, res)
	},
	async setTicket({
		dispatch,
		commit,
		state
	},ticket) {		
		
		commit(GET_TICKET, ticket)
	},
	// async saveAddress({
	// 	commit,
	// 	state
	// }) {

	// 	if(state.removeAddress.length > 0) return;

	// 	let addres = await getAddressList(state.userInfo.user_id);
	// 	commit(SAVE_ADDRESS, addres);	
	// },
}


// WEBPACK FOOTER //
// ./src/store/action.js